import type { FieldConfigurationDto } from '@tempo-io/fim3-dto';
import { Select } from '@tempo-io/sui-select';

type Option = { value: string; label: string };

export const SelectFieldInput = ({
  fieldConfiguration,
  values,
  setValues,
  isEditableText,
  includeClearOption,
  autoFocus,
}: {
  fieldConfiguration: FieldConfigurationDto;
  values: string[];
  setValues: (values: string[]) => void;
  isEditableText?: boolean;
  includeClearOption?: boolean;
  autoFocus?: boolean;
}) => {
  if (fieldConfiguration.fieldType !== 'LIST') return null;

  const options: Option[] = fieldConfiguration.options.map((o) => ({ value: o, label: o }));
  const selectedOption = options.find((o) => o.value === values[0]) ?? null;

  return (
    <Select<Option>
      className="fs-exclude"
      data-dd-action-name="FIM 3 Custom Field - select field redacted"
      data-testid="fim3-custom-field-input-select-input"
      options={options}
      value={selectedOption}
      onChange={(newValue) => {
        if (newValue === null) {
          setValues(['']);
        } else {
          setValues([newValue.value]);
        }
      }}
      isClearable={includeClearOption}
      inlineEdit={isEditableText}
      autoFocus={autoFocus}
    />
  );
};
